export default __webpack_public_path__ + "static/media/xianruida.3ccf37ba.jpg";